import 'backbone-associations';

export default class AssociatedModel extends Backbone.AssociatedModel {}
